const exposed: { [k: string]: any } = {};

if (typeof window !== "undefined") {
  (window as any).Debug = exposed;
}

export function exposeDebug(name: string, value: object | Function) {
  exposed[name] = value;
}
